import React from 'react';

const IconToggleOff: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    stroke='currentColor'
    fill='none'
    viewBox='0 0 576 512'
    height='16'
    width='16'
    focusable='false'
    role='presentation'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    className={`icon icon-toggle-off${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z'
      fill=''
    ></path>
  </svg>
);
export default IconToggleOff;
